export enum PurchaseDocumentsDateSelectionKind {
    None = 'None',
    IssueDate = 'IssueDate',
    ReceiptDate = 'ReceiptDate',
    DeliveryDate = 'DeliveryDate',
    VatDeductionDate = 'VatDeductionDate'
}
